// Email validation utility
export const validateEmail = (email: string): boolean => {
  if (!email || typeof email !== 'string') return false;
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  // Basic format check
  if (!emailRegex.test(email)) return false;
  
  // Additional checks
  const trimmedEmail = email.trim().toLowerCase();
  
  // Check for consecutive dots
  if (trimmedEmail.includes('..')) return false;

  // Check for valid length
  if (trimmedEmail.length > 254) return false;
  
  // Check local part length (before @)
  const [localPart, domain] = trimmedEmail.split('@');
  if (localPart.length > 64) return false;
  
  // Check for valid characters in local part
  const validLocalChars = /^[a-z0-9._+-]+$/;
  if (!validLocalChars.test(localPart)) return false;
  
  // Check domain format
  const domainRegex = /^[a-z0-9.-]+\.[a-z]{2,}$/;
  if (!domainRegex.test(domain)) return false;
  
  return true;
};

export const formatEmail = (email: string): string => {
  return email.trim().toLowerCase();
};
